import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import BaseModal from "@app/components/modal";
import ExcelViewer from "./index";

import "../pdf-viewer/style/modal.global.scss";

const Modal = observer(({ fileId, title, sheet, onClose, container, onBookmark, onComment }) => {
    return (
        <BaseModal
            title={title ?? ""}
            visible={true}
            onCancel={onClose}
            footer={null}
            width={1000}
            height="50vh"
            maskClosable={false}
            mask={false}
            className={classNames("excel-modal-viewer")}
            wrapClassName="excel-modal-viewer-wrap"
            getContainer={() => container}
        >
            <div className="excel-reference-viewer">
                <ExcelViewer
                    fileId={fileId}
                    goto={{ sheet }}
                    onBookmark={onBookmark}
                    onComment={onComment}
                />
            </div>
        </BaseModal>
    );
});

export default Modal;
